export const MAIN_CONTAINER_ID = 'main-container';
export const MAGIC_BOX_CONTAINER = 'magicbox-container';
